module.exports = __webpack_public_path__ + "img/_0.c4fee1bd.png";